export default __webpack_public_path__ + "static/webRotator/svg/91b4d60dc9eb3e4f83c4ecbd22b2335b.svg";